<ion-item lines="none">
    <ion-range [disabled]="readOnly" [(ngModel)]="variance" [dualKnobs]="" [min]="min" [max]="max" [step]="step">
        <ion-icon size="small" slot="start" name="remove"></ion-icon>
        <ion-icon size="small" slot="end" name="add"></ion-icon>
    </ion-range>
</ion-item>
<div class="ion-text-center">
    {{varianceValue | varianceDuration}}
</div>
